"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var CustomPropTypes = _interopRequireWildcard(require("../../../../constants/PropTypes"));

var _reactImmutableProptypes = _interopRequireDefault(require("react-immutable-proptypes"));

var _immutable = _interopRequireDefault(require("immutable"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _unescapedText = _interopRequireDefault(require("I18n/utils/unescapedText"));

var _UIFormControl = _interopRequireDefault(require("UIComponents/form/UIFormControl"));

var _UISearchInput = _interopRequireDefault(require("UIComponents/input/UISearchInput"));

var _i18n = require("ecosystem-marketplace-core/utils/i18n");

var _hubspotFeatures = require("ecosystem-marketplace-core/constants/groupTags/hubspotFeatures");

var _NestedNav = _interopRequireDefault(require("ecosystem-marketplace-core/components/nav/NestedNav"));

var _NestedNavCheckboxItem = _interopRequireDefault(require("../inputs/NestedNavCheckboxItem"));

var _UnstyledNestedNavItem = _interopRequireDefault(require("../inputs/UnstyledNestedNavItem"));

var getOpenIcon = function getOpenIcon(open) {
  return open ? 'up' : 'down';
};

var hubspotFeaturesGroupsMap = _immutable.default.OrderedMap({
  crm: _hubspotFeatures.BY_PRODUCT.CRM,
  marketing: _hubspotFeatures.BY_PRODUCT.MARKETING,
  sales: _hubspotFeatures.BY_PRODUCT.SALES,
  service: _hubspotFeatures.BY_PRODUCT.SERVICE,
  cms: _hubspotFeatures.BY_PRODUCT.CMS
}).map(function (groupFeatures) {
  return _immutable.default.Set(Object.values(groupFeatures));
});

var HubSpotFeaturesGroup = function HubSpotFeaturesGroup(_ref) {
  var groupKey = _ref.groupKey,
      groupFeatures = _ref.groupFeatures,
      _onChange = _ref.onChange,
      searchTerm = _ref.searchTerm,
      selectedFeatures = _ref.selectedFeatures,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["groupKey", "groupFeatures", "onChange", "searchTerm", "selectedFeatures"]);

  var _useState = (0, _react.useState)(groupFeatures.some(function (feature) {
    return selectedFeatures.includes(feature);
  })),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var renderedFeatures = (0, _react.useMemo)(function () {
    return groupFeatures.map(function (feature) {
      return [feature, (0, _unescapedText.default)((0, _i18n.getHubSpotFeatureI18nKey)(feature))];
    }).filter(function (_ref2) {
      var _ref3 = (0, _slicedToArray2.default)(_ref2, 2),
          featureInputLabel = _ref3[1];

      return searchTerm ? featureInputLabel.toLowerCase().indexOf(searchTerm) !== -1 : true;
    }).sortBy(function (_ref4) {
      var _ref5 = (0, _slicedToArray2.default)(_ref4, 2),
          featureInputLabel = _ref5[1];

      return featureInputLabel;
    }).map(function (_ref6) {
      var _ref7 = (0, _slicedToArray2.default)(_ref6, 2),
          feature = _ref7[0],
          featureInputLabel = _ref7[1];

      return _react.default.createElement(_NestedNavCheckboxItem.default, {
        key: feature,
        checkboxProps: {
          checked: selectedFeatures.includes(feature),
          onChange: function onChange(_ref8) {
            var checked = _ref8.target.checked;

            _onChange(checked, [feature]);
          }
        },
        title: featureInputLabel
      });
    });
  }, [groupFeatures, _onChange, searchTerm, selectedFeatures]);

  if (renderedFeatures.isEmpty()) {
    return null;
  }

  return _react.default.createElement(_UnstyledNestedNavItem.default, (0, _extends2.default)({}, rest, {
    iconRight: searchTerm ? null : getOpenIcon(open),
    open: open || !!searchTerm,
    onOpenChange: function onOpenChange(_ref9) {
      var value = _ref9.target.value;
      setOpen(value);
    },
    title: _react.default.createElement(_FormattedMessage.default, {
      message: "appMarketplace.storefront.filters.hubspotFeatures.items." + groupKey
    })
  }), renderedFeatures);
};

var HubSpotFeaturesToggleGroup = function HubSpotFeaturesToggleGroup(_ref10) {
  var onChange = _ref10.onChange,
      trackInteraction = _ref10.trackInteraction,
      selectedFeatures = _ref10.value;

  var _useState3 = (0, _react.useState)(''),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      searchTerm = _useState4[0],
      setSearchTerm = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      searchTracked = _useState6[0],
      setSearchTracked = _useState6[1];

  var trackSearch = (0, _react.useCallback)(function () {
    if (!searchTracked) {
      trackInteraction('search hubspot features');
      setSearchTracked(true);
    }
  }, [searchTracked, trackInteraction]);
  var handleChange = (0, _react.useCallback)(function (checked, values) {
    onChange(checked ? selectedFeatures.union(values) : selectedFeatures.subtract(values));
  }, [onChange, selectedFeatures]);
  return _react.default.createElement(_react.Fragment, null, _react.default.createElement(_UIFormControl.default, null, _react.default.createElement(_UISearchInput.default, {
    onBlur: function onBlur() {
      setSearchTracked(false);
    },
    onChange: function onChange(_ref11) {
      var value = _ref11.target.value;

      if (value.trim()) {
        setSearchTerm(value);
        trackSearch();
      } else {
        setSearchTerm('');
      }
    },
    placeholder: (0, _unescapedText.default)('appMarketplace.storefront.filters.hubspotFeatures.searchInputPlaceholder')
  })), _react.default.createElement(_UIFormControl.default, null, _react.default.createElement(_NestedNav.default, {
    className: "m-bottom-0"
  }, hubspotFeaturesGroupsMap.map(function (groupFeatures, groupKey) {
    return _react.default.createElement(HubSpotFeaturesGroup, {
      key: groupKey,
      groupKey: groupKey,
      groupFeatures: groupFeatures,
      onChange: handleChange,
      searchTerm: searchTerm,
      selectedFeatures: selectedFeatures
    });
  }).toArray())));
};

HubSpotFeaturesToggleGroup.propTypes = {
  onChange: _propTypes.default.func.isRequired,
  trackInteraction: _propTypes.default.func.isRequired,
  value: _reactImmutableProptypes.default.iterableOf(CustomPropTypes.hubspotFeature).isRequired
};
var _default = HubSpotFeaturesToggleGroup;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/storefront/sidebar/filters/HubSpotFeaturesToggleGroup.js
// module id = 719
// module chunks = 209 210 211 212